import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
	ConsultantManager,
	useConsultantManager,
	useConsultantManagers,
} from "../../../networking/organisation.hooks";
import AutoCompleteInput, { AutoCompleteInputProps } from "./AutoCompleteInput";

interface Props
	extends Pick<
		AutoCompleteInputProps<string, ConsultantManager>,
		"width" | "icon" | "placeholder"
	> {
	onChange: (managerId?: string) => any;
	value: string;
	hidePrefix?: boolean;
}

const ConsultantManagerAutoComplete: React.FC<Props> = ({
	value,
	onChange,
	hidePrefix,
	...rest
}) => {
	const [search, setSearch] = useState<string>();
	const { t } = useTranslation();

	const { consultantManagers } = useConsultantManagers(search, !!search);

	const { consultantManager } = useConsultantManager(value, !!value);

	function getDisplayValue(manager?: ConsultantManager) {
		return manager ? `${manager.firstName} ${manager.lastName}` : "";
	}

	return (
		<AutoCompleteInput<string, ConsultantManager>
			value={value}
			getDisplayValue={getDisplayValue}
			suggestions={consultantManagers || []}
			getValue={(m) => m.id}
			onSearch={setSearch}
			minChars={1}
			prefix={hidePrefix ? undefined : t("ORGANISATION_CONSULTANT_MANAGER")}
			onChange={onChange}
			initialValueSuggestion={consultantManager}
			{...rest}
		/>
	);
};

export default ConsultantManagerAutoComplete;
